import { ArrowRight, Home as HomeIcon } from "lucide-react";
import { Link } from "@/components/site/LocaleLink";
import { useLang } from "@/context/LanguageContext";
import { useSeo } from "@/hooks/useSeo";

export default function NotFound() {
  const { t } = useLang();
  useSeo({
    title: `${t.notFound.title} | Al-Abrad`,
    description: t.notFound.sub,
    noIndex: true,
  });

  return (
    <section className="bg-forest pt-[74px] text-cream" data-testid="not-found">
      <div className="noise pointer-events-none absolute inset-0 opacity-[0.05]" />
      <div className="container-x flex min-h-[70vh] flex-col justify-center py-24">
        <p className="eyebrow mb-4 text-gold-light">404</p>
        <h1 className="max-w-3xl font-display text-4xl font-extrabold leading-tight tracking-tight sm:text-5xl lg:text-6xl">
          {t.notFound.title}
        </h1>
        <p className="mt-6 max-w-xl text-base leading-relaxed text-cream/80 sm:text-lg">{t.notFound.sub}</p>

        <div className="mt-10 flex flex-col gap-4 sm:flex-row">
          <Link
            to="/"
            data-testid="notfound-home"
            className="group inline-flex items-center justify-center gap-2 rounded-full bg-cream px-7 py-4 text-sm font-semibold text-forest-deep transition-all duration-300 hover:-translate-y-1 hover:bg-white"
          >
            <HomeIcon className="h-4 w-4" />
            {t.nav.home}
          </Link>
          <Link
            to="/products"
            data-testid="notfound-products"
            className="group inline-flex items-center justify-center gap-2 rounded-full border border-cream/40 px-7 py-4 text-sm font-semibold text-cream transition-all duration-300 hover:-translate-y-1 hover:border-cream hover:bg-cream/10"
          >
            {t.nav.browse}
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 rtl-flip" />
          </Link>
        </div>
      </div>
    </section>
  );
}
